// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--A6TNM","list":"_7a3fb80146--list--zRJz2","author-description":"_7a3fb80146--author-description--lOv_Q"};